/**
 * membership-offer.js
 *
 * Block inside main-product. Tile checkboxes have name="bundles"
 * directly – same pattern as Produktpaket. Only one can be checked
 * at a time (radio-like). Dispatches bundle:change for price updates.
 */

if (!customElements.get('membership-offer')) {
  customElements.define(
    'membership-offer',
    class MembershipOffer extends HTMLElement {
      connectedCallback() {
        this._formId = this.getAttribute('form') || this.dataset.formId;
        this.addEventListener('change', this._onChange.bind(this));

        if (typeof theme !== 'undefined' && theme.pubsub) {
          this._unsub = theme.pubsub.subscribe(
            theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this._onCartUpdate.bind(this)
          );
        }
      }

      disconnectedCallback() {
        if (this._unsub) this._unsub();
      }

      get tileChecks() {
        return Array.from(this.querySelectorAll('[data-mo-tile-check]'));
      }

      _onChange(e) {
        const check = e.target.closest('[data-mo-tile-check]');
        if (!check) return;

        if (check.checked) {
          this.tileChecks.forEach(cb => {
            if (cb !== check) cb.checked = false;
          });
        }

        this._dispatchBundleChange();
      }

      _dispatchBundleChange() {
        const form = this._formId && document.getElementById(this._formId);
        if (!form) return;

        const checked = this.tileChecks.filter(cb => cb.checked);
        form.dispatchEvent(new CustomEvent('bundle:change', {
          detail: {
            items: checked.map(cb => ({
              id: cb.value,
              quantity: 1,
              price: cb.getAttribute('data-price') || '0'
            }))
          }
        }));
      }

      _onCartUpdate(event) {
        if (event.source === 'product-form') {
          this.tileChecks.forEach(cb => cb.checked = false);
          this._dispatchBundleChange();
        }
      }
    }
  );
}
